import { createContext } from "react";
import { FALLBACK_LANG } from "../utils";
export const LangContext = createContext(FALLBACK_LANG);
